module.exports = __webpack_public_path__ + "assets/66134705a072b225ebec2ebdf29ae6de.mp4";